import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Media from 'components/common/Media'
import Button from 'components/common/Button/Button'

const AddToQuoteButton = ({ handleClick, disabled, ...props }) =>
  <StyledButton
    data-at-add-to-quote-button
    disabled={ disabled }
    important
    full="mobile"
    large
    onClick={ handleClick }>Add To Quote
  </StyledButton>

AddToQuoteButton.propTypes = {
  disabled: PropTypes.bool,
  handleClick: PropTypes.func
}

const StyledButton = styled(Button)`
  font-size: 20px;
  padding: 12px 26px;
  ${Media.desktop`
    width: 220px;
  `}
`

export default AddToQuoteButton
